import { useState, useEffect, useContext, useRef } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
} from "react-native";
import CustomText from "../accessories/CustomText";
import Table from "./Table";
import { generateBoxShadowStyle } from "../accessories/CommonFunctions";
import { context } from "../accessories/accessories";
import { web } from "../accessories/Platform";
import ArrowSpinner from "../accessories/ArrowSpinner";
import { ScrollView } from "react-native";

const isMobileWeb = Dimensions.get("window").width <= 480;

export default function DashBoardTable(props) {
  const [screenSize, setScreenSize] = useState(
      web ? [window.innerWidth, window.innerHeight] : [0, 0]
    ),
    isSmallScreen =
      (web && screenSize[0] > 900) || Dimensions.get("window").width > 900;

  const { contextDetails, setContextDetails, navigation } = useContext(context); //Get value from context
  let { SessionId, taskTableIndex = 0 } = contextDetails,
    {
      setWebPageURL,
      handleGetUserTask = () => {},
      processingStatus = null,
      setProcessingStatus = () => {},
      setFloatPage = () => {},
    } = props;

  // const [eSignTaskExists, seteSignTaskExists] = useState(true);

  const [taskDetails, setTaskDetails] = useState(
      props["taskDetails"] || {
        activeRowData: null,
        completeRowData: null,
      }
    ),
    [index, setIndex] = useState(0),
    [tabs] = useState(["activeRowData", "completeRowData"]),
    routes = [
      {
        key: "Active",
        title: "Active",
        index: 0,
        taskCount:
          taskDetails["activeRowData"] === null
            ? -1
            : taskDetails["activeRowData"]["length"],
      },
      {
        key: "Completed",
        title: "Completed",
        index: 2,
        taskCount:
          taskDetails["completeRowData"] === null
            ? -1
            : taskDetails["completeRowData"]["length"],
      },
    ];

  useEffect(() => {
    setIndex(0);
  }, [taskTableIndex]);

  useEffect(() => {
    if (processingStatus === "changeActiveIndex") {
      setIndex(0);
      setActiveIndex(0);
      setProcessingStatus(null);
      scrollViewRef.current.scrollTo({
        animated: true,
        x: 0,
        y: 0,
      });
    }
  }, [processingStatus]);

  useEffect(() => {
    handleGetUserTask(5);

    let iIndex = index || 0;
    scrollViewRef.current.scrollTo({
      animated: true,
      x:
        (!isMobileWeb && web ? 700 : Dimensions.get("window").width - 30) *
        iIndex,
      y: 0,
    });
  }, [index]);

  const [activeIndex, setActiveIndex] = useState(0),
    scrollViewRef = useRef(null),
    width =
      (!isMobileWeb && web) || (!web && isSmallScreen)
        ? 700
        : Dimensions.get("window").width - 30;

  useEffect(() => {
    if (scrollViewRef.current) {
      const targetElement = scrollViewRef.current;
      if (activeIndex) {
        //Scroll to Completed Tab
        targetElement.scrollToEnd({ animated: true });
      } else {
        //Scroll to Active Tab
        targetElement.scrollTo({ x: 0, animated: true });
      }
    }
  }, [activeIndex]);

  useEffect(() => {
    setTaskDetails(props["taskDetails"]);
  }, [props["taskDetails"]]);

  const handleSliderPage = (event) => {
    if (contextDetails["Path"] === "DashBoard") {
      const { x } = event.nativeEvent.contentOffset;
      let indexOfNextScreen = Math.round(x / width);

      indexOfNextScreen = indexOfNextScreen >= 1 ? 1 : 0; //Screen contentOffset exceeding the

      setActiveIndex(indexOfNextScreen);
      setIndex(indexOfNextScreen);
    }
  };

  return (
    <View
      style={
        !web && [
          generateBoxShadowStyle(2, 3, "black", 0.2, 3, 8, "black"),
          {
            shadowColor: "rgba(0, 0, 0, 0.30)",
            shadowRadius: 10,
            shadowOpacity: 0.8,
          },
        ]
      }
    >
      <View
        style={[
          {
            flexDirection: "column",
            backgroundColor: "#fff",
            width:
              (!isMobileWeb && web) || (!web && isSmallScreen)
                ? 700
                : Dimensions.get("window").width - 30,
            height: !isMobileWeb && web ? 100 : 80,
            marginTop: 20,
            // paddingHorizontal: 10,
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            borderColor: "rgb(228, 230, 233)",
            // borderBottomWidth: 2,
            // borderBottomColor: "black",
          },
          web && generateBoxShadowStyle(2, 3, "black", 0.2, 3, 8, "black"),
          web && {
            shadowColor: "rgba(0, 0, 0, 0.30)",
            shadowRadius: 10,
            shadowOpacity: 0.8,
          },
        ]}
      >
        <View
          style={{
            flex: !isMobileWeb && web ? "unset" : 3,
            justifyContent: "space-between",
            paddingHorizontal: 5,
            paddingVertical: 13,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <CustomText
              bold={true}
              style={{
                fontSize: !isMobileWeb && web ? 20 : 15,
                paddingHorizontal: 10,
                flexDirection: "row",
              }}
            >
              My Assignments & To-Do's
              {processingStatus === "gettingUserTask" && (
                <View
                  style={{ height: web ? 18 : 15, marginLeft: web ? 5 : 25 }}
                >
                  <ArrowSpinner size={web ? 18 : 15} isSpinner={true} />
                </View>
              )}
            </CustomText>
          </View>
        </View>
        <View
          style={{
            ...{
              flexDirection: "row",
              flex: 1.5,
              justifyContent: "space-around",
            },
          }}
        >
          {routes.map((route, iIndex) => {
            return (
              <TouchableOpacity
                activeOpacity={1}
                key={iIndex}
                style={{
                  flexDirection: "row",
                  alignSelf: "flex-end",
                  minWidth: !isMobileWeb && web ? 150 : 80,
                  justifyContent: "center",
                  paddingVertical: !isMobileWeb && web ? 10 : 8,
                  width: "50%",
                  borderBottomWidth: 3,
                  borderBottomColor: index === iIndex ? "#111" : "#fff",
                }}
                onPress={() => {
                  setIndex(iIndex);
                }}
              >
                <CustomText
                  bold={index === iIndex}
                  style={[
                    styles["taskName"],
                    {
                      color: index === iIndex ? "black" : "black",
                    },
                  ]}
                >
                  {route.title}
                </CustomText>
                <View style={[styles["taskCount"], { alignSelf: "center" }]}>
                  <CustomText
                    style={{
                      color: "#427ECB",
                      alignSelf: "center",
                      fontSize: !isMobileWeb && web ? 13 : 13,
                      paddingTop: !isMobileWeb && web ? 1 : 0,
                    }}
                    bold={true}
                  >
                    {route.taskCount === -1 ? (
                      <ArrowSpinner
                        size={!isMobileWeb && web ? 12 : 10}
                        style={{ marginTop: !isMobileWeb && web ? 2 : -4 }}
                        color="#fff"
                      />
                    ) : (
                      route.taskCount
                    )}
                  </CustomText>
                </View>
              </TouchableOpacity>
            );
          })}
        </View>
      </View>
      <SafeAreaView
        style={[
          {
            flex: 1,
            width: width,
            overflow: "hidden",
            borderBottomRightRadius: 8,
            borderBottomLeftRadius: 8,
          },
          generateBoxShadowStyle(2, 3, "black", 0.2, 3, 8, "black"),
          {
            shadowColor: "rgba(0, 0, 0, 0.30)",
            shadowRadius: 10,
            shadowOpacity: 0.8,
          },
        ]}
      >
        <ScrollView
          horizontal={true}
          scrollEventThrottle={100}
          pagingEnabled={true}
          showsHorizontalScrollIndicator={false}
          onMomentumScrollEnd={handleSliderPage}
          ref={scrollViewRef}
          style={[
            {
              backgroundColor: "#fff",
              maxWidth: width * 2,
            },
          ]}
        >
          <View style={{ height: index !== 0 ? 45 : "auto" }}>
            <Table
              tab={tabs[0]}
              rowData={taskDetails[tabs[0]] || null}
              setWebPageURL={setWebPageURL}
              navigation={navigation || props["navigation"] || null}
              setFloatPage={setFloatPage}
            />
          </View>
          <View style={{ height: index !== 1 ? 45 : "auto" }}>
            <Table
              tab={tabs[1]}
              rowData={taskDetails[tabs[1]] || null}
              setWebPageURL={setWebPageURL}
              navigation={navigation || props["navigation"] || null}
              setFloatPage={setFloatPage}
            />
          </View>
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  taskName: {
    fontSize: !isMobileWeb && web ? 20 : 15.5,
    textTransform: "capitalize",
    marginRight: 2,
  },
  taskCount: {
    width: web ? 20 : 18,
    height: web ? 25 : 23,
    borderRadius: 5,
    backgroundColor: "#B8D0E9",
    justifyContent: "center",
    marginLeft: 5,
  },
  emptyRow: {
    backgroundColor: "#fff",
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#e4e6e9",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
});
